import { verifyInvitationVerifyInvitationTokenGetOptions } from '@/generated/@tanstack/react-query.gen'
import ImageHead from '@/assets/images/hydra_score_head_sm.webp'
import { useQuery } from '@tanstack/react-query'
import { FaLinkedinIn, FaYoutube, FaFacebookF } from 'react-icons/fa'
import { useSearchParams } from 'react-router-dom'
import { cn } from '@/lib/utils'
import Spinner from '../../../components/Spinner'
import { useEffect, useState } from 'react'

export default function SecitonActivation() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')

  if (!token) {
    window.location.replace('/sign-in')
  }

  const handleIconClick = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  const [countdown, setCountdown] = useState(10)

  const {
    isLoading,
    // error: data,
    // data: error,
    error,
    data,
  } = useQuery({
    ...verifyInvitationVerifyInvitationTokenGetOptions({
      path: { token: token! },
    }),
    retry: false,
    enabled: !!token,
  })

  useEffect(() => {
    if (data) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(timer)
            window.location.replace('/')
          }
          return prev - 1
        })
      }, 1000)

      return () => clearInterval(timer)
    }
  }, [data])

  return (
    <section className="splash-icon" style={{ minHeight: '770px' }}>
      {isLoading && <Spinner />}
      <div className="signin-box">
        <div className="flex justify-center flex-wrap items-center px-6 py-12 max-w-3xl mx-auto bg-white rounded">
          <div className="w-full px-6">
            <div
              className="items-center w-full flex flex-col"
              style={{ padding: '1em 1em' }}
            >
              <img src={ImageHead} alt="Head" />
              <h1
                className={cn('text-3xl text-center mb-10 font-bold', {
                  'text-primary': data,
                  'text-destructive': error,
                })}
              >
                {/* Account Activation */}
                {error ? ' Oops, your link has expired or is invalid.' : null}
                {data ? 'Account Activated Successfully!' : ''}
              </h1>
              {error ? (
                <div className="text-center">
                  <p>
                    Please ask your Hydra Score Administrator to resend your
                    invitation.
                  </p>
                </div>
              ) : null}
              {data ? (
                <>
                  <p>
                    Your account has been successfully activated. You can now
                    log-in using the auto-generated password received via email.
                  </p>
                  <p>
                    You will be redirected to the login page shortly. If you are
                    not redirected automatically, please click below to log in
                  </p>

                  <p>Auto redirecting in {countdown} seconds. </p>

                  <button
                    onClick={() => window.location.replace('/')}
                    className="w-full bg-primary text-white px-7 py-5 mt-5 text-2xl font-medium uppercase rounded shadow-md hover:bg-[#01589d] transition duration-150 ease-in-out hover:shadow-lg active:bg-primary mb-3"
                  >
                    Login
                  </button>
                </>
              ) : null}
            </div>
          </div>
        </div>
        <div className="mt-6 text-center">
          <p className="text-gray-400 mb-4">
            Hydra Score™ is a precision water and land data analytics platform.
          </p>
          <div className="flex justify-center space-x-4">
            <FaFacebookF
              style={{
                width: '20px',
                height: '20px',
                color: 'gray',
                cursor: 'pointer',
                borderRadius: '4px',
              }}
              onClick={() =>
                handleIconClick(
                  'https://www.facebook.com/profile.php?id=61560861611781'
                )
              }
            />
            <FaYoutube
              style={{
                width: '20px',
                height: '20px',
                color: 'gray',
                cursor: 'pointer',
                borderRadius: '4px',
              }}
              onClick={() =>
                handleIconClick(
                  'https://www.youtube.com/channel/UCOfzLw8uh-KvxDKqDjsmBzA'
                )
              }
            />
            <FaLinkedinIn
              style={{
                width: '20px',
                height: '20px',
                color: 'gray',
                cursor: 'pointer',
                borderRadius: '4px',
              }}
              onClick={() =>
                handleIconClick(
                  'https://www.linkedin.com/company/hydra-score/about/?viewAsMember=true'
                )
              }
            />
          </div>
        </div>
      </div>
    </section>
  )
}
